jQuery(function ($) {
    $(document).ready(init);
    function init() {
        $('.landing-dna .header-slider').slick({
            infinite: true,
            autoplay: true,
            speed: 1500,
            dots: true,
            arrows: false,
            adaptiveHeight: true,
            accessibility: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

        $("[data-bg]").each(function () {
            var dataImg = $(this).data('bg');
            $(this).css('background-image', 'url(' + dataImg + ')');
        });

        $(document).on('click', '.form-hidden label', function (e) {
            e.preventDefault();
            $(this).closest('.form-hidden').toggleClass('form-open');
            $(this).closest('.form-hidden').find('.checkbox-ctn').slideToggle();
        });
    }
});